<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.add_nilai"
      @keydown.esc="dialog.add_nilai = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <div
          class="title font-weight-bold black--text text-center mt-4 mb-2">
          Penilaian Skor Presensi
        </div>

        <div
          class="body-2 text-center mb-4">
          Tentukan nilai berdasarkan informasi dibawah ini:
        </div>

        <v-divider class="mx-4 mb-3 mt-0"/>
        
        <v-card-text
          class="pb-1 mt-2">
          <ValidationObserver 
            ref="form">
            <v-form>
              <div
                class="body-2 mb-6">
                <ul
                  style="position: relative; left: -10px;">
                  <li
                    v-for="(item, index) in info"
                    :key="index"
                    :class="index < info.length - 1 ? 'mb-2' : ''"
                    v-html="item">  
                  </li>
                </ul>
              </div>

              <ValidationProvider 
                name="label_score" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <!-- <span class="red--text">*</span> -->
                  Masukan Angka Skor Kehadiran
                  <!-- <span class="error--text">
                    (wajib diisi)
                  </span> -->
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  placeholder="Contoh. 70"

                  suffix="%"

                  v-model="form.label_score"
                  :success="form.label_score !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Masukan Angka Skor Kehadiran {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.label_score !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="score" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <!-- <span class="red--text">*</span> -->
                  Masukan Angka Bobot
                  <!-- <span class="error--text">
                    (wajib diisi)
                  </span> -->
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  placeholder="Contoh. 80"

                  v-model="form.score"
                  :success="form.score !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Masukan Angka Bobot {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.score !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="save_nilai()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.add_nilai = false; dialog.fullscreen = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.reset"
      @keydown.esc="dialog.reset = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Reset Nilai

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin mereset nilai data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.reset"
            :loading="process.reset"
            @click="resetes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Reset
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.reset"
            @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="pt-0">
        <v-card
          flat
          :color="set_color_rgb_soft"
          style="border-radius: 10px;">
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="10"
                class="py-0">
                <div
                  class="d-flex align-center">
                  <v-avatar 
                    size="40" 
                    tile>
                    <v-img 
                      alt="amanata" 
                      :src="detail.image_url === '' ? require('@/assets/image/member_default.jpg') : detail.image_url"
                      class="ma-auto"
                      style="border-radius: 10px;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="white">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <div
                    class="font-weight-bold ml-4"
                    :style="`color: ${set_color};`">
                    {{ detail.code }}
                  </div>

                  <v-divider
                    vertical
                    class="my-2 mx-4"
                    style="border: 1px solid #e0e0e0; border-radius: 50px;" />

                  <div
                    class="font-weight-bold"
                    :style="`color: ${set_color};`">
                    {{ detail.name }}
                  </div>

                  <v-divider
                    vertical
                    class="my-2 mx-4"
                    style="border: 1px solid #e0e0e0; border-radius: 50px;" />

                  <div
                    class="font-weight-bold"
                    :style="`color: ${set_color};`">
                    {{ detail.position }}
                  </div>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="2"
                class="py-0">
                <v-menu
                  ref="picker"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      readonly
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih Tanggal"
                      prepend-inner-icon="mdi-calendar-range"

                      hide-details

                      clearable
                      @click:clear="filter.date = ''; fetchData(); fetchSkor();"

                      v-on="on"
                      v-bind="attrs"

                      v-model="filter.date"
                      class="no_box_white"
                      style="border-radius: 10px;">
                    </v-text-field>
                  </template>

                  <v-date-picker 
                    type="month"
                    :color="set_color"
                    v-model="filter.date"
                    @input="picker = false; fetchData(); fetchSkor();">
                  </v-date-picker>
                </v-menu>
              </v-col>

              <!-- <v-col
                cols="12"
                md="2"
                class="py-0">
                <v-btn
                  block
                  height="40"
                  color="white"
                  elevation="0"
                  class="text-capitalize d-flex align-center"
                  style="border-radius: 8px;">
                  <v-icon style="opacity: 60%;">mdi-alert-decagram-outline</v-icon>
                  
                  <span
                    class="ml-1"
                    style="opacity: 60%;">
                    Komplain
                  </span>
                </v-btn>
              </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col 
        cols="12"
        class="pb-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-sheet 
              height="calc(100vh - 380px)">
              <v-calendar
                v-model="filter.date_focus"

                ref="calendar"
                type="month"

                :color="set_color_rgb"
                :events="list"

                @click:event="showEvent">
              </v-calendar>

              <v-menu
                v-model="selected.open"
                :close-on-content-click="false"
                :activator="selected.element"
                offset-y
                bottom
                transition="slide-y-transition">
                <v-card v-if="Object.keys(selected.event).length > 0"
                  width="400"
                  flat>
                  <v-toolbar
                    dark
                    elevation="0"
                    :color="selected.event.color">
                    <v-toolbar-title 
                      class="body-1 font-weight-bold text-capitalize">
                      {{ selected.event.user_name }}
                    </v-toolbar-title>

                    <v-spacer/>

                    <v-btn 
                      icon
                      @click="selected.open = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text>
                    <div
                      class="caption text-capitalize mb-1 d-flex align-center">
                      <v-icon x-small>mdi-calendar-month-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ selected.event.status === 'leave' ? 'Meninggalkan Jam Kerja': selected.event.status  }}
                      </span>
                    </div>

                    <div
                      class="title font-weight-bold black--text">
                      {{ selected.event.date | date }}
                    </div>

                    <v-divider
                      class="mt-2 mb-6"
                      style="border-top: 3px solid #f2f2f2; border-radius: 50px;" />

                    <v-row v-if="selected.event.status !== 'ijin' && selected.event.status !== 'cuti'"
                      class="mb-6">
                      <v-col
                        cols="6"
                        class="py-0">
                        <div
                          class="caption">
                          {{ selected.event.status === 'hadir' ? 'Datang:' : 'Jam Mulai' }}
                        </div>

                        <div
                          class="green--text">
                          <span v-if="selected.event.status === 'hadir'">
                            {{ selected.event.start_datetime | datetime }}
                          </span>

                          <span v-if="selected.event.status === 'leave'">
                            {{ selected.event.start_datetime | time }}
                          </span>
                        </div>
                      </v-col>

                      <v-col
                        cols="6"
                        class="py-0">
                        <div
                          class="caption">
                          {{ selected.event.status === 'hadir' ? 'Pulang:' : 'Jam Selesai' }}
                        </div>

                        <div>
                          <span v-if="selected.event.status === 'hadir'">
                            <span v-if="selected.event.end_datetime !== ''"
                              class="red--text">
                              {{ selected.event.end_datetime | datetime }}
                            </span>

                            <span v-else>
                              -
                            </span>
                          </span>

                          <span v-if="selected.event.status === 'leave'"
                            class="red--text">
                            {{ selected.event.end_datetime | time }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>

                    <div v-if="selected.event.status !== 'hadir'"
                      class="body-2 mb-4">
                      <div
                        class="black--text font-weight-bold mb-2">
                        Alasan:
                      </div>

                      <div>
                        {{ selected.event.leave_reason !== '' ? selected.event.leave_reason : '-' }}
                      </div>
                    </div>

                    <div v-if="selected.event.status === 'hadir'"
                      class="body-2 font-weight-bold black--text mb-4">
                      Lokasi:
                    </div>

                    <div v-if="selected.event.status === 'hadir'"
                      class="mb-6">
                      <gmap-map
                        ref="gmap"
                        :center="center"
                        :zoom="15"
                        :scrollwheel="false"
                        :options="{
                          zoomControl: true,
                          mapTypeControl: false,
                          scaleControl: false,
                          streetViewControl: false,
                          rotateControl: false,
                          fullscreenControl: true,
                          disableDefaultUi: false
                        }"
                        style="width:100%; height: 30vh;">
                        <gmap-marker
                          :position="currentPosition.latlng"
                          :icon="currentPosition.icon">
                        </gmap-marker>
                      </gmap-map>
                    </div>

                    <div v-if="selected.event.status === 'hadir'"
                      class="body-2 font-weight-bold black--text mb-2">
                      Jarak:
                    </div>

                    <v-row v-if="selected.event.status === 'hadir'">
                      <v-col
                        cols="6"
                        class="pt-0">
                        <div
                          class="caption">
                          Datang:
                        </div>

                        <div>
                          <span v-if="selected.event.end_range !== ''">
                            <strong>{{ selected.event.end_range }}</strong> Meter
                          </span>

                          <span v-else>
                            -
                          </span>
                        </div>
                      </v-col>

                      <v-col
                        cols="6"
                        class="pt-0">
                        <div
                          class="caption">
                          Pulang:
                        </div>

                        <div>
                          <span v-if="selected.event.end_range !== ''">
                            <strong>{{ selected.event.end_range }}</strong> Meter
                          </span>

                          <span v-else>
                            -
                          </span>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row v-if="selected.event.status === 'hadir'">
                      <v-col
                        cols="6"
                        class="pt-0">
                        <div
                          class="caption mb-1">
                          Gambar Datang:
                        </div>

                        <v-img v-if="selected.event.start_image_url !== ''"
                          contain
                          alt="amanata" 
                          width="100%"
                          height="auto"
                          :src="selected.event.start_image_url"
                          class="ma-auto border-radius">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <div v-else>
                          <strong>-</strong>
                        </div>
                      </v-col>

                      <v-col
                        cols="6"
                        class="pt-0">
                        <div
                          class="caption mb-1">
                          Gambar Pulang:
                        </div>

                        <v-img v-if="selected.event.end_image_url !== ''"
                          contain
                          alt="amanata" 
                          width="100%"
                          height="auto"
                          :src="selected.event.end_image_url"
                          class="ma-auto border-radius">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <div v-else>
                          <strong>-</strong>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-sheet>

            <v-row>
              <v-col
                cols="11"
                class="pr-0">
                <v-card
                  @click="dialog.add_nilai = true; reset();"
                  flat
                  :color="set_color_rgb_soft"
                  style="border: 1px solid #e0e0e0; border-right: 0px; border-radius: 4px 0px 0px 4px;">
                  <v-card-text
                    class="font-weight-bold"
                    :style="`color: ${set_color};`">
                    Nilai Skor Presensi{{ detail_skor.indicator_score === '' ? ', klik disini' : ` adalah ${detail_skor.indicator_score}` }}
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col
                cols="1"
                class="pl-0">
                <v-card
                  flat
                  min-height="56"
                  style="border: 1px solid #e0e0e0; border-radius: 0px 4px 4px 0px;">
                  <v-card-text
                    class="font-weight-bold text-center">
                    {{ detail_skor.indicator_label_score }}%
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-alert v-if="message.error.length > 0"
              class="mx-6"
              type="error" 
              dense
              text 
              prominent>
              {{ message.error }}
            </v-alert>
          </v-card-text>

          <v-card-actions
            class="ma-2 mt-0 mb-3">
            <v-spacer/>

            <v-btn
              @click="$router.go(-1)"
              outlined
              style="border-radius: 10px;"
              class="body-2 font-weight-bold text-capitalize red--text">
              <v-icon color="red" small class="mr-1">mdi-arrow-left-thick</v-icon>
              Kembali
            </v-btn>

            <v-btn v-if="detail_skor.indicator_id !== ''"
              @click="toReset()"
              color="orange"
              elevation="0"
              style="border-radius: 10px;"
              class="body-2 font-weight-bold text-capitalize white--text">
              <v-icon small class="mr-1">mdi-reload</v-icon>

              Reset Nilai
            </v-btn>

            <v-btn
              @click="$router.go(-1)"
              color="green"
              elevation="0"
              style="border-radius: 10px;"
              class="body-2 font-weight-bold text-capitalize white--text">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Simpan Penilaian
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          fullscreen: false,

          add_nilai: false,
          reset: false
        },

        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],

        center: {
          lat: null,
          lng: null
        },
        currentPosition: {},

        filter: {
          unit: '',
          date: moment().format('YYYY-MM'),
          date_focus: moment().format('YYYY-MM-DD')
        },

        selected: {
          item: {},
          reset: {},

          open: false,
          element: null,
          event: {}
        },

        info: [
          'Kurang dari 50% (Skor 20)',
          '50% sampai dengan / kurang dari 60% (Skor 40)',
          '60% sampai dengan / kurang dari 70% (Skor 60)',
          '70% sampai dengan / kurang dari 80% (Skor 80)',
          'Lebih dari 80% (Skor 100)'
        ],

        picker: false,

        detail: {},
        detail_skor: {},

        unit: [],
        list: [],
        pagination: {},
        limit: 20,

        form: {
          id: '',
          user_id: '',
          label_score: '',
          score: '',

          indicator_id: ''
        },

        process: {
          load: false,

          form: false,
          reset: false,

          detail: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.1)`
      }
    },
    watch: {
      'filter.date': function(val) {
        this.filter.date_focus = moment(`${val}-01`).format('YYYY-MM-DD')
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchDetail()
        this.fetchData()
        this.fetchSkor()
      },

      async fetchDetail () {
        this.process.detail = true

        let params = {
          id: this.$route.params.id
        }

        await get('admin/user/detail', { params })
        .then(response => {
          let res = response.data

          this.process.detail = false
            
          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      async fetchData () {
        this.process.load = true

        let params = {
          user_id: this.$route.params.id,
          unit_id: this.filter.unit,

          year: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[0] : '',
          month: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[1] : ''
        }

        this.list = []

        await get('kpi/event/detail', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            let data = res.results.data

            data.map((obj) => {
              this.list.push({
                name: obj.status === 'hadir' ? 'Hadir' : obj.status === 'ijin' ? 'Ijin' : obj.status === 'leave' ? 'Meninggalkan Jam Kerja' : 'Cuti',
                date: obj.date,
                start: obj.start_datetime !== '' ? obj.start_datetime : obj.date,
                end: obj.end_datetime !== '' ? obj.end_datetime : obj.date,
                
                user_id: obj.user_id,
                user_name: obj.user_name,
                status: obj.status,
                leave_reason: obj.leave_reason,


                start_datetime: obj.start_datetime,
                end_datetime: obj.end_datetime,
                
                start_range: obj.start_range,
                end_range: obj.end_range,

                unit_id: obj.unit_id,

                start_latitude: obj.start_latitude,
                end_latitude: obj.end_latitude,

                start_longitude: obj.start_longitude,
                end_longitude: obj.end_longitude,

                start_image_url: obj.start_image_url,
                end_image_url: obj.end_image_url,

                color: obj.status === 'hadir' ? 'green' : obj.status === 'ijin' ? 'blue' : obj.status === 'leave' ? 'orange' : 'red'
              })
            })

            this.pagination = res.results.pagination
          }
        })
      },

      async fetchSkor () {
        let params = {
          user_id: this.$route.params.id,
          unit_id: this.filter.unit,
          
          year: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[0] : '',
          month: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[1] : '',

          indicator_id: 9
        }

        await get('kpi/event/data', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail_skor = res.results.data.length > 0 ? res.results.data[0] : {
              indicator_label_score: 0,
              indicator_score: 0
            }
          }
        })
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: this.detail_skor.indicator_id,
          user_id: this.detail.id,
          label_score: this.detail_skor.indicator_label_score,
          score: this.detail_skor.indicator_score,

          indicator_id: 9
        }

        this.process.form = false

        this.message.error = ''
      },

      async save_nilai () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.detail_skor.indicator_label_score === '' ? 'kpi/event/add_score' : 'kpi/event/update_score'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.add_nilai = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchSkor()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toReset () {
        this.selected.reset = this.detail_skor

        this.dialog.reset = true
      },
      async resetes () {
        this.message.error = ''

        this.process.reset = true

        await post('kpi/event/reset_score', {
          data: {
            id: this.selected.reset.indicator_id
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.process.reset = false
            this.dialog.reset = false

            this.selected.reset = {}
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchSkor()
          } else {
            this.process.reset = false
            this.message.error = res.message
          }
        })
      },

      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selected.event = event

          this.selected.element = nativeEvent.target

          this.$gmapApiPromiseLazy().then(() => {
            this.center = {
              lat: parseFloat(this.selected.event.start_latitude),
              lng: parseFloat(this.selected.event.start_longitude)
            }

            this.currentPosition = {
              latlng: {
                lat: parseFloat(this.selected.event.start_latitude),
                lng: parseFloat(this.selected.event.start_longitude)
              },
              icon: {
                url: require('@/assets/image/location_pin.png'),
                scaledSize: new google.maps.Size(50, 50),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(25, 50)
              }
            }
          })

          setTimeout(() => {
            this.selected.open = true
          }, 10)
        }

        if (this.selected.open) {
          this.selected.open = false

          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      }
    }
  }
</script>